import Icon from '../../Icon/Icon';
import Props from './types';
import S from './StatusStyles';

function Status({
  label, backgroundColor, title, width, onClick, icon,
}: Props):JSX.Element {
  return (
    <S.Wrapper
      backgroundColor={backgroundColor}
      onClick={onClick}
      title={title}
      width={width}
    >
      {icon !== undefined && <Icon iconKey={icon} className="status-icon" />}
      <p> {label} </p>
    </S.Wrapper>
  );
}

export default Status;
